/**
 * Search Modal Component
 *
 */
class SearchModal extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    this.openSearchModal = document.querySelectorAll('.open-searchform');
    this.searchFormContainer = this.querySelector('.searchform');
    this.searchFormContainer?.addEventListener('keyup', (event) => {
      if (event.code) {
        event.code.toUpperCase() === 'ESCAPE' && this.close()
      }
    });

    this.openSearchModal.forEach(toggleBtn =>{
      toggleBtn.addEventListener('click', function(event){
        _this.onToggleBtnClick(event);
      });
      toggleBtn.setAttribute('role', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
    this.querySelector('.search-modal__close-button')?.addEventListener('click', this.close.bind(this));
  }

  /**
   * To check if search modal is open or closed
   * 
   * @returns {boolean} true/false
   */
  isOpen() {
    return this.searchFormContainer.hasAttribute('open');
  }

  /**
   * Toggle Search Modal on search Icon click
   *
   * @param {event} Event instance
   */
  onToggleBtnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.searchFormContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /**
   * Close Search Modal on body click if not within the Modal
   *
   * @param {event} Event instance
   */
  onBodyClick(event) {
    if (!event.target?.closest('.snize-ac-results')) {
      if (!this.contains(event.target)) this.close(false);
    }
  }

  /**
   * Open Search Modal and add attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  open(_event) {
    document.querySelectorAll(".megamenu").forEach(element => {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
      }
    })
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.searchFormContainer.setAttribute('open', true);
    this.classList.add('open__modal');
    if(siteOverlay) siteOverlay.prototype.showOverlay();
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.querySelector('.megamenu').classList.remove('open');
    // document.getElementById('site-overlay-custome').classList.remove('overlay--body-custome');
    document.querySelector('body').classList.remove('scroll-fixed-custome');
    Utility.trapFocus(this);
    Utility.forceFocus(document.getElementById('Search-In-Modal'));
    document.querySelector('body').classList.remove('Mega_menu');
    controlBadgeInterval(true);
  }

  /**
   * Close Search Modal and remove attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  close(_focusToggle = true) {
    if (this.classList.contains('open__modal')) {
      Utility.removeTrapFocus(document.querySelector('[type="search"]'));
      console.log(this.searchFormContainer,'this.searchFormContainer')
      this.searchFormContainer?.removeAttribute('open');
      this.classList.remove('open__modal');
      if(siteOverlay) siteOverlay.prototype.hideOverlay();
      document.body.removeEventListener('click', this.onBodyClickEvent);
      controlBadgeInterval(false);
    }
  }
}
customElements.define('search-modal', SearchModal);